<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'8'"   [loanTypeId]="14"  serviceName="early retirement planning"></app-banner-enquiry-form>

<!-- Hero Section with Get In Touch Form -->
<!-- <section class="form-section">
 
  <div class="row d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-7">
        <div class="card transparent-card">
            <h1>We help you to Achieve your Financial Goals</h1>
            <a href="/appointment" class="btn btn-orange small-button ">Schedule a Meeting</a>
        </div>
    </div>


    <div class="col-md-5">
      <div class="form-container">
        <h2>GET IN TOUCH</h2>
        <h3 class="slogan">Your journey to financial freedom starts here!</h3>
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
          <input type="email" formControlName="email" placeholder="Enter your Email" required>
          <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
          <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
          <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
        </form>
      </div>
    </div>
</div>
    

  
</section> -->
    

  
  <!-- <div class="form-container">

  
   
  </div> -->


  <!-- <div class="row">
    <div class="col-md-7">
      <h1 style="color: whitesmoke;">We help you to Achieve your Financial Goals</h1>
  <button class="schedule-button">Schedule a Meeting</button>
    </div>
    <div class="col-md-5">

      <h2>GET IN TOUCH</h2>
      <h3>Your journey to financial freedom starts here!</h3>
      <form>
        <input type="text" placeholder="Enter your Name" required>
        <input type="email" placeholder="Enter your Email" required>
        <input type="tel" placeholder="Enter Phone Number" required>
        <input type="text" placeholder="Enter your Message" required>
        <button type="submit">Submit</button>
      </form>
    </div>
  </div> -->
<!-- </section> -->

<div class="plan-section">
  <h2 class="plan-title">Early Retirement</h2>
  <p class="plan-description">
    Early Retirement Planning involves preparing financially to retire from your career earlier than the traditional retirement age. While the typical retirement age is around 65-70, early retirees aim to achieve financial independence and retire as early as their 40s or 50s.  </p>

  <h3 class="important-heading">
    Why Consider Early Retirement?
    <div class="underline"></div>
  </h3>

  <p class="plan-description">
    The allure of early retirement is undeniable. It offers the freedom to pursue passions, travel, and spend more time with loved ones. However, it requires meticulous planning and disciplined financial management. Here are some benefits and considerations: </p>




<!-- Benefits Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Benefits</h2>
    <p>
      <strong>Freedom:</strong> Early retirement provides the freedom to live life on your terms.
      <br><br>
      <strong>Health:</strong> Enjoy better health and vitality during your retirement years.
      <br><br>
      <strong>Time:</strong> Spend more time with family, travel, and pursue hobbies.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/er/23746899_pension_13.jpg" alt="Setting Financial Goals">
  </div>
</section>


  <section class="service-section">
    <img src="assets\er\23391959_pension_1.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>Considerations
    </h2>
      <p>
        Once you have identified your Financial goals, you should develop a financial plan. A financial plan is a detailed strategy for achieving your Financial goals. It includes a budget, an investment plan, a retirement plan, an estate plan, and a risk management plan. A Financial plan is tailored to your needs and circumstances and considers factors like age, income, expenses, assets, liabilities, and risk tolerance.
         </p>
    </div>
  </section>

  
  <!-- Implementing and Monitoring Your Plan Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Implementing and Monitoring Your Plan</h2>
    <p>
      <strong>Financial Stability:</strong> Ensure you have enough savings to sustain your lifestyle.
      <br><br>
      <strong>Healthcare:</strong> Plan for healthcare costs, as Medicare eligibility begins at 65.
      <br><br>
      <strong>Longevity:</strong> Consider the potential for a more extended retirement period.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/er/23746899_pension_13.jpg" alt="Setting Financial Goals">
  </div>
</section>



  
  <section class="service-section">
    <img src="assets\er\pension_21.jpg" alt="Setting Financial Goals">
    <div class="content">
      <h2>Steps for Early Retirement Planning
    </h2>
      <p>
        <strong>Set Clear Goals: </strong>Define your retirement lifestyle and financial goals. <br>
        <strong>Calculate Expenses: </strong>Estimate your annual retirement expenses. <br>
      <strong>Save Aggressively:</strong>   Maximize contributions to retirement accounts. <br>
       <strong> Invest Wisely:</strong> Diversify investments and manage risk. <br>
       <strong>Budget and Track:</strong>  Monitor spending and adjust as needed. <br>
       <strong>Healthcare Planning:</strong>  Understand healthcare options and costs. <br>
       <strong>Retirement Income:</strong>  Plan for alternative income streams.      </p>
    </div>
    
  </section>


 <!-- Conclusion Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Conclusion</h2>
    <p>
      Early retirement planning is a journey that requires careful consideration and dedication. By following these steps and seeking professional guidance, you can achieve financial independence and retire early. Start planning today to make your early retirement dreams a reality!
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/Services/fd.svg" alt="Monitoring and Adjusting">
  </div>
</section>

</div>


<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container"> 
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>
  
    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly! 
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>
  
</section>



<app-footer></app-footer>
